export default {"src":"/bnb/_next/static/media/bnb-dark.030d1c84.svg","height":26,"width":26};